<template>
    <div class="home">
     
      <DetalleInspeccionHomeComponent />
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import DetalleInspeccionHomeComponent from '@/components/DetalleInspeccionHomeComponent.vue'
  
  export default {
    name: 'CotizacionView',
    components: {
        DetalleInspeccionHomeComponent
    }
  }
  </script>